import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Content } from 'rsuite';
import * as PERMISSIONS from '../../../constants/permissions/inventory';
import { viewAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';

import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import InventoryAuditLogList from '../../../containers/inventory/AuditLogList';
import InventoryAuditLogSearch from '../../../containers/inventory/AuditLogSearch';
import { resetAuditLogsSearchQuery } from '../../../redux/Inventory/actions/components/audit-log-search';

export default () => {
  const dispatch = useDispatch();
  useEffect(
    () => () => {
      dispatch(resetAuditLogsSearchQuery());
    },
    []
  );
  return (
    <InventoryPageLayout>
      <AccessControl
        allowWhenAll={[
          viewAccess(PERMISSIONS.ITEM),
          viewAccess(PERMISSIONS.AUDIT)
        ]}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Items Audit Logs">
          <InventoryAuditLogSearch />
        </PageHeader>
        <Content>
          <InventoryAuditLogList />
        </Content>
      </AccessControl>
    </InventoryPageLayout>
  );
};
